__turbopack_context__.v({
  "bottomNav": "wjjhNa_bottomNav",
  "icon": "wjjhNa_icon",
  "label": "wjjhNa_label",
  "navItem": "wjjhNa_navItem",
});
